import { createContext } from 'react';

import { SupportTicketRootStore } from '../support-ticket-root-store';

export const SupportTicketStoreContext = createContext<SupportTicketRootStore>(
	undefined as unknown as SupportTicketRootStore
);
export const StoreProvider = SupportTicketStoreContext.Provider;
